import ScLayout from '@/layouts/sc'

export default [
  {
    name: 'sc',
    path: '/',
    redirect: '/enterpeople',
    component: ScLayout,
    children: [
      {
        name: 'enterpeople',
        path: '/enterpeople',
        component: () => import('_sc/enterpeople'),
        meta: {
          title: '出租屋录入'
        }
      },
      {
        name: 'liveMonitor',
        path: '/liveMonitor',
        component: () => import('_sc/liveMonitor'),
        meta: {
          title: '实时监控'
        }
      }
    ]
  }
]
